import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors.js'

export interface IAiSuggestedFieldsRequest {
    systemPrompt: string
    userPrompt: string
}

export const aiSuggestedFieldsApi = {
    async getSuggestedFields (body: IAiSuggestedFieldsRequest): Promise<Array<string>> {
        try {
            const { Data } = await $axios.post('/Summarizer/GenerateCallParameters/', {
                SystemPrompt: body.systemPrompt,
                UserPrompt: body.userPrompt
            })
            return Data || []
        } catch (e) {
            parseCatch(e, false, 'AI Suggested Fields')
            return []
        }
    }
}
